import { INBOX_FILTERS, type InboxFilter } from "@nerves/shared";
import { createFileRoute } from "@tanstack/react-router";
import { Inbox, type InboxSearch } from "@/components/inbox/Inbox";

export function validateInboxSearch(s: Record<string, unknown>): InboxSearch {
  return {
    filter: INBOX_FILTERS.includes(s.filter as InboxFilter) ? (s.filter as InboxFilter) : undefined,
    product:
      typeof s.product === "string" && /^[A-Za-z0-9]{2,10}$/.test(s.product) ? s.product.toUpperCase() : undefined,
  };
}

export const Route = createFileRoute("/_app/")({
  validateSearch: validateInboxSearch,
  component: () => <Inbox search={Route.useSearch()} selectedRef={null} />,
});
